"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CorrectLink_1 = __importDefault(require("@CommonFrontendBackend/Utils/CorrectLink"));
var LinkInput_1 = __importDefault(require("../LinkInput"));
var VoidLinkComponent = (function (_super) {
    __extends(VoidLinkComponent, _super);
    function VoidLinkComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openLinkMenu = function () {
            _this.props.open();
        };
        _this.saveLink = function (rawHref) {
            var href = (0, CorrectLink_1.default)(rawHref);
            _this.props.updateLink(href);
        };
        _this.removeLink = function () {
            _this.props.close();
            _this.props.updateLink("");
        };
        _this.onInputBlur = function (event, href) {
            _this.saveLink(href);
            _this.props.close();
        };
        _this.blockPropagation = function (event) {
            event.stopPropagation();
        };
        return _this;
    }
    VoidLinkComponent.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "void-link-component" },
            react_1.default.createElement(LinkInput_1.default, { onInputClick: this.blockPropagation, onInputBlur: this.onInputBlur, focus: !this.props.href, href: this.props.href, placeholder: this.props.placeholder, removeLink: this.removeLink })));
    };
    return VoidLinkComponent;
}(react_1.default.Component));
exports.default = VoidLinkComponent;
